'use client';

import { c as _c } from "react/compiler-runtime";
import { useMemo } from 'react';
import { GenericErrorState } from './generic-error-state';
import { NetworkErrorState } from './network-error-state';
import type { LucideIcon } from 'lucide-react';
interface SmartErrorStateProps {
  icon?: LucideIcon;
  title?: string;
  description?: string;
  showBorder?: boolean;
  className?: string;
}
function SmartErrorState(t0) {
  const $ = _c(9);
  const {
    icon,
    title,
    description,
    showBorder: t1,
    className
  } = t0;
  const showBorder = t1 === undefined ? true : t1;
  let t2;
  bb0: {
    if (typeof window === "undefined") {
      t2 = true;
      break bb0;
    }
    t2 = navigator.onLine;
  }
  const isOnline = t2;
  if (!isOnline) {
    let t3;
    if ($[0] !== className || $[1] !== showBorder) {
      t3 = <NetworkErrorState showBorder={showBorder} className={className} />;
      $[0] = className;
      $[1] = showBorder;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    return t3;
  }
  let t3;
  if ($[3] !== className || $[4] !== description || $[5] !== icon || $[6] !== showBorder || $[7] !== title) {
    t3 = <GenericErrorState icon={icon} title={title} description={description} showBorder={showBorder} className={className} />;
    $[3] = className;
    $[4] = description;
    $[5] = icon;
    $[6] = showBorder;
    $[7] = title;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
}
export { SmartErrorState };